import { Trans, useTranslate } from "@similarweb/i18n-provider";
import { AlertBanner } from "@similarweb/ui-components";

type Props = {
    domain: string;
};

export const WebsiteMismatchAlert = ({ domain }: Props) => {
    const { translate } = useTranslate();
    return (
        <AlertBanner
            variant="error"
            data-automation="gsc-website-mismatch-alert"
        >
            <AlertBanner.Image />
            <AlertBanner.Description>
                <Trans
                    t={translate}
                    i18nKey="rankTracker.gsc.websiteMismatch.banner"
                    values={{ domain }}
                    components={{ strong: <strong /> }}
                />
            </AlertBanner.Description>
        </AlertBanner>
    );
};
